import React from 'react';
import PropTypes from 'prop-types';
import { Box, Menu, MenuButton, MenuList, MenuItem, Portal } from '@chakra-ui/react';
import { Trans } from 'react-i18next';
import { MoreHorizontal } from '../../images';

const MoreMenu = ({ placement, items, buttonProps, ...props }) => {
  return (
    <Menu bg="brand.10" placement={placement}>
      <>
        <MenuButton {...buttonProps}>
          {
            <Box mx={4} {...props}>
              <MoreHorizontal />
            </Box>
          }
        </MenuButton>
        <Portal>
          <MenuList color="black">
            {items.map((item, index) => (
              <MenuItem key={index} onClick={() => item.action()}>
                <Trans i18nKey={item.i18nKey} />
              </MenuItem>
            ))}
          </MenuList>
        </Portal>
      </>
    </Menu>
  );
};

MoreMenu.propTypes = {
  placement: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      i18nKey: PropTypes.string,
      action: PropTypes.func,
    })
  ),
  buttonProps: PropTypes.object,
};

export default MoreMenu;
